import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HaccpReportsComponent } from './haccp-reports.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { TableModule } from 'primeng/table';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { HaccpReportsRoutingModule } from './haccp-reports-routing.module';
import { ValidateRulesService } from '../shared/validate-rules.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { SharedModule } from '../shared/shared.module';


import { TabViewModule } from 'primeng/tabview';
import { QdsTabbar, QdsDivider, QdsChip, QdsButton, QdsTitle } from '@quartzds/core-angular';

@NgModule({
  imports: [
    CommonModule,
    HaccpReportsRoutingModule,
    TableModule,
    RadioButtonModule,
    CheckboxModule,
    ButtonModule,
    ToastModule,
    NgbModule,
    FormsModule,
    SharedModule,
    TranslateModule,
    MultiSelectModule,
    DropdownModule,
    TabViewModule,
    QdsTabbar, 
    QdsDivider, 
    QdsChip, 
    QdsButton,
    QdsTitle
  ],
  declarations: [HaccpReportsComponent],
  exports: [
   
  ],
  providers: [ValidateRulesService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HaccpReportsModule { }
